const getVimeoLink = (url) => {
  const vimeoRegex = /(?:vimeo)\.com.*(?:videos|video|channels|)\/([\d]+)/i;
  const parsed = url.match(vimeoRegex);

  return "//player.vimeo.com/video/" + parsed[1];
}

export default getVimeoLink